export const COMPANY_LEGAL_NAME = "NOMISS Technologies Private Limited";

export const SUPPORT_EMAIL = "support@nomiss.in";

export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;

export const LEGAL_LAST_UPDATED = "27 August 2026";

export const APP_METADATA = {
  androidPackageName: "com.nomiss.mobileapp",
  androidLauncherActivity: "com.nomiss.mobileapp.MainActivity",
  androidPlayStoreUrl:
    "https://play.google.com/store/apps/details?id=com.nomiss.mobileapp",
  iosBundleId: "com.nomiss.mobileapp",
  iosAppStoreId: 6786553331,
  iosAppStoreUrl: "https://apps.apple.com/app/id6786553331",
} as const;
